import { useState, useCallback } from "react";

export function useSummaryLoadingState() {
  const [summaryLoadingMap, setLoadingMap] = useState<Record<string, boolean>>({});

  const setSummaryLoading = useCallback((summaryId: string, loading: boolean) => {
    setLoadingMap((prev) => ({ ...prev, [summaryId]: loading }));
  }, []);

  return [summaryLoadingMap, setSummaryLoading] as const;
}
